import { useTranslation } from "react-i18next";
import { RecordCards } from "../../../../../../components";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { envChangeType } from "../../../../../../plugins/utils";
import typeEnum from "../../../../enumerations/typeEnum.js";
import styles from "./style.module.scss";

const Details = ({ data, hasNextPage, fetchNextPage, isFetchingNextPage, radioValue }) => {
  const { t } = useTranslation();

  const renderCardContent = (data) => {
    switch (radioValue) {
      case typeEnum.EQC:
        return (
          <div className={styles.container}>
            <div className={styles.row}>
              <div>{t("label.commission")}</div>
              <div className={styles.bold}>
                {t(`currency.symbol.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`) +
                  " " +
                  moneyFormat(data?.money)}
              </div>
            </div>
            <div className={styles.row}>
              <div>{t("label.equipment")}</div>
              <div className={styles.bold}>{moneyFormat(data?.buy_money)}</div>
            </div>
            <div className={styles.row}>
              <div>{t("label.note")}</div>
              <div className={styles.bold}>{data?.ext}</div>
            </div>
          </div>
        );
      default:
        return (
          <>
            <div className={styles.left}>
              <div>{t("label.name")}</div>
              <div className={`${styles.bold} ${styles.marginTop}`}>
                {data?.mobile + t("user.myTeam.detail.vip", { num: data?.level })}
              </div>
            </div>
            <div className={styles.right}>
              <div>{t("label.amount")}</div>
              <div className={`${styles.bold} ${styles.marginTop}`}>
                {t(`currency.symbol.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`) +
                  " " +
                  moneyFormat(data?.price)}
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <RecordCards
      data={data}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      content={renderCardContent}
    />
  );
};

export default Details;
